import { mapGetters } from 'vuex';
import axios from 'axios';
import Environments from 'src/constants/environments.js';

export default {
  data() {
    return {
      usercentricsLoaded: false,
    };
  },
  computed: {
    ...mapGetters('config', ['currentCollectivity']),
  },
  methods: {
    environment() {
      return this.config.ENVIRONMENT;
    },

    injectCrossDomainBridge() {
      let domainBridgeBaseUrl = this.currentCollectivity?.crossDomainBridgeBaseUrl;

      if (domainBridgeBaseUrl != null) {
        const scriptContent = `
          window.UC_UI_DOMAINS = {
            crossDomainConsentSharingIFrame: '${domainBridgeBaseUrl}/cross-domain-bridge.html',
          };
        `;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.text = scriptContent;

        const head = document.head;
        const metaTags = head.querySelectorAll('meta');

        if (metaTags.length > 0) {
          const lastMeta = metaTags[metaTags.length - 1];
          head.insertBefore(script, lastMeta.nextSibling);
        } else {
          head.appendChild(script);
        }
      }
    },

    async loadUsercentricsAndGTM() {
      try {
        await this.loadUsercentricsScript();
        await this.setDefaultConsent();
        await this.loadGoogleTagManager();
      } catch (err) {
        console.error('Consent/GTM loading failed:', err);
      }
    },

    loadUsercentricsScript() {
      return new Promise((resolve, reject) => {
        const script1 = document.createElement('script');
        script1.async = true;
        script1.id = 'usercentrics-cmp';
        script1.setAttribute('data-language', 'nl');
        script1.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';
        script1.setAttribute('data-settings-id', this.currentCollectivity?.userCentricsId ?? '22zMTDzJKUHdgK');

        if (this.environment() !== Environments.Production) {
          script1.setAttribute('data-version', 'preview');
          script1.setAttribute('data-disable-tracking', '');
        }

        script1.onload = () => {
          this.usercentricsLoaded = true;
          resolve();
        };
        script1.onerror = reject;

        document.head.appendChild(script1);
      });
    },

    // The enviroment has a 62.5% font-size on the HTML tag.
    // Changing this to 100% has a huge impact. Usercentrics uses this value
    // as a base value for its font. The code below injects a fixed font size
    // into UserCentrics' shadow dom.
    fixStyling() {
      const interval = setInterval(() => {
        const userCentricsElement = document.querySelector('[id^="usercentrics-root"]');

        if (userCentricsElement && userCentricsElement.shadowRoot) {
          const innerDiv = userCentricsElement.shadowRoot.querySelector('#app-focus-lock');

          if (innerDiv) {
            innerDiv.style.fontSize = '14px';
            clearInterval(interval);
          }
        }
      }, 300);
    },

    async setDefaultConsent() {
      const file = await axios.get('/statics/js/consentSettings.txt');
      const script = document.createElement('script');
      script.text = file.data;

      document.head.appendChild(script);
    },

    async loadGoogleTagManager() {
      const code = this.currentCollectivity?.GTMCode ?? this.config.DEFAULT_GTM_CODE;

      const file = await axios.get('/statics/js/googleTagManagerScript.txt');
      const script = document.createElement('script');
      script.text = file.data.replace('$GTMCode', `'${code}'`);

      document.head.appendChild(script);
    },
  },

  mounted() {
    this.injectCrossDomainBridge();
    this.loadUsercentricsAndGTM();
    this.fixStyling();
  },
};
